import a11yReport from './a11y-report';
import a11yScan from './a11y-scan';
import a11yScanner from './a11y-scanner';
import action from './action';
import article from './article';
import artist from './artist';
import artistFunctionRelation from './artist-function-relation';
import asset from './asset';
import assetDownloadLink from './asset-download-link';
import assetFormat from './asset-format';
import assetFormatRelation from './asset-format-relation';
import assetTokenConfig from './asset-token-config';
import audioplayer from './audioplayer';
import audioplayerShop from './audioplayer-shop';
import audioplayerTrack from './audioplayer-track';
import calendarEvent from './calendar-event';
import category from './category';
import channel from './channel';
import collection from './collection';
import contentItem from './content-item';
import contest from './contest';
import contestFormField from './contest-form-field';
import coopPartner from './coop-partner';
import customShop from './custom-shop';
import digitalOrderConfig from './digital-order-config';
import division from './division';
import domain from './domain';
import externalReference from './external-reference';
import externalValue from './external-value';
import frontendUser from './frontend-user';
import heroHeader from './hero-header';
import html from './html';
import job from './job';
import label from './label';
import link from './link';
import linkPattern from './link-pattern';
import liveEvent from './live-event';
import livePartner from './live-partner';
import location from './location';
import mediaEmbed from './media-embed';
import mediaEvent from './media-event';
import mediaPartner from './media-partner';
import mlp from './mlp';
import mlpAddToWallet from './mlp-add-to-wallet';
import mlpCountdown from './mlp-countdown';
import mlpDownloadLinkForm from './mlp-download-link-form';
import mlpLiveEventFeed from './mlp-live-event-feed';
import mlpModule from './mlp-module';
import mlpNewsFeed from './mlp-news-feed';
import mlpPage from './mlp-page';
import mlpProductFeed from './mlp-product-feed';
import mlpStagePlusStream from './mlp-stage-plus-stream';
import mlpText from './mlp-text';
import mlpVoucher from './mlp-voucher';
import mlpZatap from './mlp-zatap';
import newsletter from './newsletter';
import newsletterConfig from './newsletter-config';
import newsletterForm from './newsletter-form';
import newsletterTarget from './newsletter-target';
import organization from './organization';
import person from './person';
import product from './product';
import productContributor from './product-contributor';
import productElement from './product-element';
import productFamily from './product-family';
import productFamilyContributor from './product-family-contributor';
import productTrack from './product-track';
import productTrackContributor from './product-track-contributor';
import productWork from './product-work';
import productWorkContributor from './product-work-contributor';
import section from './section';
import sftpUser from './sftp-user';
import shopifyStore from './shopify-store';
import shortUrl from './short-url';
import shortUrlTarget from './short-url-target';
import spacer from './spacer';
import story from './story';
import taxon from './taxon';
import taxonomy from './taxonomy';
import teaser from './teaser';
import tradePartner from './trade-partner';
import urlAlias from './url-alias';
import user from './user';
import userRole from './user-role';
import vhost from './vhost';
import webSeries from './web-series';

export default {
  a11yReport,
  a11yScan,
  a11yScanner,
  action,
  article,
  artistFunctionRelation,
  artist,
  assetDownloadLink,
  assetFormatRelation,
  assetFormat,
  assetTokenConfig,
  asset,
  audioplayerShop,
  audioplayerTrack,
  audioplayer,
  calendarEvent,
  category,
  channel,
  collection,
  contentItem,
  contestFormField,
  contest,
  coopPartner,
  customShop,
  digitalOrderConfig,
  mlpDownloadLinkForm,
  division,
  domain,
  externalReference,
  externalValue,
  frontendUser,
  heroHeader,
  html,
  job,
  label,
  linkPattern,
  link,
  liveEvent,
  livePartner,
  location,
  mediaEmbed,
  mediaEvent,
  mediaPartner,
  mlpAddToWallet,
  mlpCountdown,
  mlpLiveEventFeed,
  mlpModule,
  mlpNewsFeed,
  mlpPage,
  mlpProductFeed,
  mlpStagePlusStream,
  mlpText,
  mlpVoucher,
  mlpZatap,
  mlp,
  newsletterConfig,
  newsletterForm,
  newsletterTarget,
  newsletter,
  organization,
  person,
  productContributor,
  productElement,
  productFamilyContributor,
  productFamily,
  productTrackContributor,
  productTrack,
  productWorkContributor,
  productWork,
  product,
  section,
  sftpUser,
  shopifyStore,
  shortUrlTarget,
  shortUrl,
  spacer,
  story,
  taxon,
  taxonomy,
  teaser,
  tradePartner,
  urlAlias,
  userRole,
  user,
  vhost,
  webSeries,
};
